export default __webpack_public_path__ + "static/media/vlcsnap-2021-10-19-09h04m48s844.86173032.jpg";